<template>
  <div class="popup small">
    <Loader v-if="loading" />
    <h4 class="popup__title middle">Удаление транзакции</h4>

    <span class="popup__subtitle">
      Вы точно желаете удалить данную транзакцию?
    </span>

    <div class="actions">
      <button class="button btn-primary" @click="closeAll()">Отмена</button>
      <button class="button btn-primary" @click="deleteTransactionFunc()">Удалить</button>
    </div>
  </div>
</template>

<script>
import {popups} from '@/mixins/popups'
import {mapActions, mapState} from "vuex";
import Loader from '@/components/common/Loader.vue'

export default {
  name: "removeTransactionPopup",
  mixins: [popups],
  components: {
    Loader
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    ...mapState({
      idRemoveTransaction: state => state.popups.idRemoveTransaction,
    })
  },
  methods: {
    ...mapActions({
      deleteTransaction: 'deleteTransaction',
    }),
    async deleteTransactionFunc() {
      this.loading = true
      await this.deleteTransaction(this.idRemoveTransaction)

      this.loading = false
      //this.closeAll()
    },
  },
  mounted() {}
}
</script>

<style scoped lang="scss">
@import "../../styles/variables";

.popup {
  :deep(.loader) {
    height: 200%;
    width: 200%;
    left: -50%;
    top: -50%;
    border-radius: 25px;
    transform: scale(0.5);
    svg {
      position: unset;
    }
  }
}
</style>